import type { CarrierType } from 'hooks/useMixOrderAdvisory/types';

import type { CarrierLabel } from './types';

export const DENSITY_REFERENCE_TEMP_F = 60;

// Exact formulation-code match set, compared case-insensitively against the short
// code from chemical-db enrichment. Mirrors DRY_FORMULATION_CODES in the backend's
// services/mixOrder.ts.
export const DRY_FORMULATION_CODES = new Set(['DF', 'WDG', 'WP', 'WSP', 'SP', 'SG', 'G']);

// Exact formulation-code match set for codes that are definitively LIQUID.
// Any code not in DRY_FORMULATION_CODES nor LIQUID_FORMULATION_CODES has
// unknown drType — detectDrType returns null so the backend can fall back
// to a caller-supplied mixOrderGroup rather than forcing the liquid bucket.
// This prevents AMS (crystalline), NIS, MSO, COC (adjuvants), and future
// unknown codes from being silently mislabeled as LIQUID and demoted into
// the wrong Precision Labs group.
export const LIQUID_FORMULATION_CODES = new Set([
    'AS',
    'CS',
    'EC',
    'EW',
    'F',
    'ME',
    'OD',
    'SC',
    'SE',
    'SL'
]);

// Keyword heuristics for Group 0 (compatibility agents) and Group 1 (microbials).
// These run against the product labelName when the enrichment API does not
// provide an explicit flag. Keep the lists conservative — false positives would
// mis-order a product into group 0 or 1 and potentially harm the mix.
export const COMPATIBILITY_AGENT_KEYWORDS = ['compatibility', 'compex', 'blendmaster', 'tankmate'];

export const MICROBIAL_KEYWORDS = [
    'microbial',
    'inoculant',
    'rhizobium',
    'bacillus',
    'trichoderma',
    'mycorrhizal'
];

export const CARRIER_TYPE_FROM_LABEL: Record<CarrierLabel, CarrierType> = {
    'Liquid Fert': 'TEN_34_0',
    'UAN 28': 'UAN_28',
    'UAN 32': 'UAN_32',
    Water: 'WATER'
};
